/* eslint-disable no-restricted-syntax */
import { ITranslationsCollections } from '@estee/elc-service';
import { Account } from './Account';
import { AccountErrors } from './AccountErrors';
import { Cart } from './Cart';
import { CartErrors } from './CartErrors';
import { Checkout } from './Checkout';
import { Communications } from './Communications';
import { Errors } from './Errors';
import { General } from './General';
import { Loyalty } from './Loyalty';
import { LoyaltyMarketing } from './LoyaltyMarketing';
import { LoyaltyDashboard } from './LoyaltyDashboard';
import { Product } from './Product';
import { ProductAttributes } from './ProductAttributes';
import { User } from './User';
import { Common } from './Common';
import { Offers } from './Offers';
import { Stores } from './Stores';
import { Search } from './Search';
import { ApptBooking } from './ApptBooking';
import { Compliance } from './Compliance';
import { Vto } from './Vto';
import { DeliveryTout } from './DeliveryTout';
import { Orders } from './Orders';
import { Gifting } from './Gifting';

export const translationsCollections: ITranslationsCollections = {
    elc_account: Account,
    elc_account_errors: AccountErrors,
    elc_appt_booking: ApptBooking,
    elc_cart: Cart,
    elc_cart_errors: CartErrors,
    elc_checkout: Checkout,
    elc_common: Common,
    elc_communications: Communications,
    elc_compliance: Compliance,
    elc_errors: Errors,
    elc_general: General,
    elc_loyalty: Loyalty,
    elc_loyalty_marketing: LoyaltyMarketing,
    elc_loyalty_dashboard: LoyaltyDashboard,
    elc_offers: Offers,
    elc_vto: Vto,
    elc_product: Product,
    elc_product_attributes: ProductAttributes,
    elc_stores: Stores,
    elc_user: User,
    elc_search: Search,
    elc_delivery_tout: DeliveryTout,
    elc_orders: Orders,
    elc_gifting: Gifting
};
